module.exports = __webpack_public_path__ + "assets/img/Clementi MRT Interchange.7cf7b552.jpg";